// Phones are stored normalized (digits only, e.g. 12045551234); the client owns
// display formatting. Falls back to the raw input when it isn't a 10/11-digit
// North American number.
export const formatPhone = (phone?: string | null): string => {
  if (!phone) return '';

  const digits = phone.replace(/\D/g, '');
  const local = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

  if (local.length !== 10) return phone;

  const formatted = `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
  return digits.length === 11 ? `+1 ${formatted}` : formatted;
};
